import { useMemo } from "react";

import { TreemapGraph } from "@similarweb/pro-logic-components";

import { ALL_TOPICS_NAME } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/LLMConsts";
import { getChartConfig } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/domain-influence/domains-map/config";
import type { ITreemapNode } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/domain-influence/domains-map/types";
import type { ISourceDomainResponse } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/domain-influence/types";
import { formatTopicFromId } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/domain-influence/utils";
import { TABLE_ID } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/url-table/consts";
import { allTrackers } from "app/services/track/track";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { transformData } from "./utils";

interface IDomainsMapProps {
    data: ISourceDomainResponse;
    topicId: string;
}

export const DomainsMap = ({ data, topicId }: IDomainsMapProps) => {
    const transformedData = useMemo<ITreemapNode[]>(() => data && transformData(data), [data]);
    const visibleData = transformedData?.find((node) => node.id === topicId)?.children || [];

    const onDomainClick = (topic: string, domain: string): void => {
        void proNavigator.updateParams(
            {
                domainFilter: domain,
                ...(topic !== ALL_TOPICS_NAME ? { topic } : {}),
            },
            { reload: false },
        );

        //scroll to table
        const tableEl = document.getElementById(TABLE_ID);
        tableEl?.scrollIntoView({ behavior: "smooth", block: "start" });

        allTrackers.dispatchTrackEvent("Filter Table", "Click", `Domains Map/Filter/${topic}/${domain}`);
    };

    return (
        <TreemapGraph
            graphConfig={getChartConfig(onDomainClick)}
            data={visibleData}
            firstLevelName={formatTopicFromId(topicId)}
            levelStyling="flat"
        />
    );
};
